import React from "react";
import { Box, Typography, Button, Chip, Snackbar, Alert } from "@mui/material";
import ArrowUpwardRoundedIcon from "@mui/icons-material/ArrowUpwardRounded";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import PageHeader from "../../components/PageHeader";
import SectionCard from "../../components/SectionCard";
import { tokens } from "../../theme";
import { channels } from "../../data/mockData";

const mono = '"IBM Plex Mono", monospace';
const th = { textAlign: "left", color: tokens.textDim, fontSize: 10.5, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 700, padding: "10px 12px", borderBottom: `1px solid ${tokens.border}`, whiteSpace: "nowrap" };
const td = { padding: "11px 12px", borderBottom: `1px solid ${tokens.border}`, fontSize: 12.5, verticalAlign: "middle" };

export default function Marketing() {
  const [snack, setSnack] = React.useState(null);
  return (
    <Box>
      <PageHeader
        title="Marketing"
        crumb="Operate / Marketing"
        subtitle="Channel performance · recommendation-only budgets"
        actions={<Chip size="small" label="Advisory · no auto-spend" sx={{ bgcolor: "rgba(91,168,245,0.13)", color: tokens.blue, fontWeight: 600 }} />}
      />

      <Box sx={{ display: "flex", gap: 1, alignItems: "center", p: 1.5, mb: 1.75, borderRadius: "10px", borderLeft: `3px solid ${tokens.blue}`, border: `1px solid ${tokens.border}`, background: tokens.cardBg }}>
        <InfoRoundedIcon sx={{ color: tokens.blue, fontSize: 18 }} />
        <Typography variant="caption" color="text.secondary">Backend conversions diverge from platform-reported (post-ATT). Budget changes are <b>recommended, never auto-applied</b>.</Typography>
      </Box>

      <SectionCard title="Channels" subtitle="Last 7 days">
        <Box sx={{ overflowX: "auto" }}>
          <Box component="table" sx={{ width: "100%", borderCollapse: "collapse" }}>
            <thead><tr><th style={th}>Channel</th><th style={th}>Spend (7d)</th><th style={th}>FTDs</th><th style={th}>Cost / FTD</th><th style={th}>Trend</th><th style={th}>AI rec</th><th style={th}></th></tr></thead>
            <tbody>
              {channels.map((c) => (
                <tr key={c.ch}>
                  <td style={{ ...td, fontWeight: 600 }}>{c.ch}</td>
                  <td style={{ ...td, fontFamily: mono }}>${c.spend.toLocaleString()}</td>
                  <td style={{ ...td, fontFamily: mono }}>{c.ftd}</td>
                  <td style={{ ...td, fontFamily: mono }}>${c.cpf}</td>
                  <td style={td}>{c.trend === "up"
                    ? <Box component="span" sx={{ color: tokens.secondary, display: "inline-flex", alignItems: "center", gap: 0.3 }}><ArrowUpwardRoundedIcon sx={{ fontSize: 13 }} /> rising</Box>
                    : <Box component="span" sx={{ color: tokens.textDim }}>▬ flat</Box>}</td>
                  <td style={{ ...td, fontFamily: mono, color: tokens.textDim }}>{c.rec}</td>
                  <td style={td}>{c.rec === "hold"
                    ? <Chip size="small" label="hold" sx={{ bgcolor: tokens.surface2, color: tokens.textDim, fontWeight: 600, height: 20 }} />
                    : <Button size="small" variant="outlined" color="inherit" onClick={() => setSnack(`${c.ch} ${c.rec} queued — needs admin approval`)}>Review</Button>}</td>
                </tr>
              ))}
            </tbody>
          </Box>
        </Box>
      </SectionCard>

      <Snackbar open={Boolean(snack)} autoHideDuration={3000} onClose={() => setSnack(null)} anchorOrigin={{ vertical: "bottom", horizontal: "right" }}>
        <Alert severity="info" variant="filled" onClose={() => setSnack(null)}>{snack}</Alert>
      </Snackbar>
    </Box>
  );
}
